export const LANDING_SETTINGS = {
  LANDING_BLOCKS: 1,
  PARTNERS: 2,
  LANDING_TEXTS: 3,
  REVIEWS: 4,
  ONLINE_POLL: 5,
};

export const LANDING_BLOCK_KEYS = {
  INTRO: 'intro',
  ABOUT: 'about',
  DEMO: 'demo',
  INDIVIDUAL_TARIFFS: 'individual-tariffs',
  TARIFFS: 'tariffs',
  REVIEWS: 'reviews',
  PARTNERS: 'partners',
  VIDEO_MATERIALS: 'video-materials',
  RESUME_AND_VACANCIES: 'resume-and-vacancies',
  VIDEOSESSIONS: 'videosessions',
  VIDEO_INTERVIEW_RECORD: 'video-interview-record',
  RESUME_AND_VACANCIES_RECORD: 'resume-and-vacancies-record',
  VIDEO_POLL_RECORD: 'video-poll-record',
  LINK_PLACEMENT: 'link-placement',
  PORTFOLIO: 'portfolio',
  MARKETPLACE: 'marketplace',
  FEED: 'feed',
  CONNECT: 'connect',
};

export const SECTIONS = [
  {
    key: LANDING_BLOCK_KEYS.INTRO,
    enabled: true,
    adminTitle: {ru: 'Титульная страница', en: 'Title page'},
  },
  {
    key: LANDING_BLOCK_KEYS.ABOUT,
    enabled: true,
    adminTitle: {ru: 'О ваших потребностях и наших возможностях', en: 'About'},
    slides: true,
  },
  {
    key: LANDING_BLOCK_KEYS.DEMO,
    enabled: true,
    adminTitle: {ru: 'Бесплатный демо-доступ', en: 'Free demo access'},
    slides: true,
  },
  {
    key: LANDING_BLOCK_KEYS.INDIVIDUAL_TARIFFS,
    enabled: true,
    adminTitle: {ru: 'Индивидуальный тариф', en: 'Individual rate'},
    slides: true,
  },
  {
    key: LANDING_BLOCK_KEYS.TARIFFS,
    enabled: true,
    adminTitle: {ru: 'Услуги и тарифы', en: 'Services and rates'},
  },
  {
    key: LANDING_BLOCK_KEYS.REVIEWS,
    enabled: true,
    adminTitle: {ru: 'Отзывы наших клиентов', en: 'Our customer reviews'},
  },
  {
    key: LANDING_BLOCK_KEYS.PARTNERS,
    enabled: true,
    adminTitle: {ru: 'С нами уже работают', en: 'Our customers'},
  },
  {
    key: LANDING_BLOCK_KEYS.VIDEO_MATERIALS,
    enabled: true,
    adminTitle: {ru: 'Видеоматериалы', en: 'Video materials'},
  },
  {
    key: LANDING_BLOCK_KEYS.RESUME_AND_VACANCIES,
    enabled: true,
    adminTitle: {ru: 'База данных резюме и вакансий', en: 'CVs and vacancies database'},
    slides: true,
  },
  {
    key: LANDING_BLOCK_KEYS.VIDEOSESSIONS,
    enabled: true,
    adminTitle: {ru: 'Бесплатные онлайн-видеосессии', en: 'Free online video sessions'},
    slides: true,
  },
  {
    key: LANDING_BLOCK_KEYS.VIDEO_INTERVIEW_RECORD,
    enabled: true,
    adminTitle: {ru: 'Запись видеособеседований', en: 'Video interviews recording'},
    slides: true,
  },
  {
    key: LANDING_BLOCK_KEYS.RESUME_AND_VACANCIES_RECORD,
    enabled: true,
    adminTitle: {ru: 'Запись видеорезюме и видеовакансий', en: 'Video CV and video vacancy recording'},
    slides: true,
  },
  {
    key: LANDING_BLOCK_KEYS.VIDEO_POLL_RECORD,
    enabled: true,
    adminTitle: {ru: 'Запись видеоопросов', en: 'Video surveys recording'},
    slides: true,
  },
  {
    key: LANDING_BLOCK_KEYS.LINK_PLACEMENT,
    enabled: true,
    adminTitle: {ru: 'Размещение ссылок', en: 'Link placement'},
    slides: true,
  },
  {
    key: LANDING_BLOCK_KEYS.PORTFOLIO,
    enabled: true,
    adminTitle: {ru: 'Портфолио соискателей', en: 'Job seekers portfolio'},
    slides: true,
  },
  {
    key: LANDING_BLOCK_KEYS.MARKETPLACE,
    enabled: true,
    adminTitle: {ru: 'Онлайн-биржа для подбора сотрудников', en: 'Marketplace for staff selection'},
    slides: true,
  },
  {
    key: LANDING_BLOCK_KEYS.FEED,
    enabled: true,
    adminTitle: {ru: 'Общая лента', en: 'General feed'},
    slides: true,
  },
  {
    key: LANDING_BLOCK_KEYS.CONNECT,
    enabled: true,
    adminTitle: {ru: 'Присоединяйтесь', en: 'Join us'},
  },
];
